import { apiCall, secondaryApi } from './ApiUtils'

export const publishLog = (token, { message, stack, url, siteAccessed, type }) => apiCall(`logs/`, {
    method: 'POST',
    body: { message, stack, url, siteAccessed, type }
}, token, secondaryApi)

export const getLogs = (lastEvalKey = null) => apiCall(`logs/${lastEvalKey ? "?lastEvalKey="+ JSON.stringify(lastEvalKey) : ""}`, {
    method: 'GET'
}, null, secondaryApi)